import styled from '@emotion/styled';
import { Avatar, LinearProgress, ListItem, ListItemText, Typography } from '@material-ui/core';
import { CloudUpload } from '@material-ui/icons';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

export type Props = ClassAttributes<HTMLElement> & {
  file: File;
  className?: string;
};

const FileListUploadingItem = ({ file, className }: Props) => {
  return (
    <ListItem className={className}>
      <Avatar>
        <CloudUpload />
      </Avatar>

      <ListItemText
        primary={
          <Typography variant="subtitle1" noWrap>
            {file.name}
          </Typography>
        }
        secondary={
          <Secondary>
            <Label variant="body1" color="textSecondary">
              <FormattedMessage id="file_list.file_list_uploading_item.uploading" />
            </Label>

            <Progress>
              <LinearProgress />
            </Progress>
          </Secondary>
        }
        disableTypography
      />
    </ListItem>
  );
};

const Secondary = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  gridTemplateAreas: "'label progressBar'",
});

const Label = styled(Typography)({
  gridArea: 'label',
  marginRight: 16,
});

const Progress = styled('div')({
  gridArea: 'progressBar',
  padding: '7.5px 0',
});

export default FileListUploadingItem;
